export const iosStore = 'https://apps.apple.com/se/app/twiceme/id1443727990'
export const androidStore =
  'https://play.google.com/store/apps/details?id=twiceme.myiceinfo.org'
